import mod from "-!./ProductCard.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./ProductCard.js?vue&type=script&lang=js&external"